<template>
    <div class="zhzfzmain">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <div class="item" v-for="(item,index) in list" :key="index" @click="goxq(item.id)" >
                    <div class="title">
                        <div class="bline"></div>
                        <span>{{item.stationName}}</span>
                    </div>
                    <div class="xxj" >管辖小区：<span>{{item.villageNames}}</span></div>
                    <div class="xxj" >工作职责：<span>{{item.workIntro}}</span></div>
                </div>
            </van-list>  
        </van-pull-refresh>
    </div>    
</template>
<script>
export default {
    data() {
        return{
            loading: false,
            finished: false,
            refreshing: false,
            pageNum:0,
            list:[]
        }
    },
    mounted(){
    },
    methods:{
        goxq(id){
            this.$router.push({path:'/zhzfz/xq',query:{id:id}})
        },
        onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
        onLoad() {
            setTimeout(() => {
                if (this.refreshing) {
                    // 清空列表数据
                    this.pageNum = 0;
                    this.list = [];
                    this.refreshing = false;
                }
                this.getdata()
                this.pageNum++;
                this.loading = false;
                if (this.list.length >= 3) {
                    this.finished = true;
                }
            }, 500);
        },
        getdata(){
            this.$axios.get('/api/v1/workstation/list', {
                params: {
                    pageNum:this.pageNum,
                    pageSize:15,
                }
            }).then(res => {
                this.list.push(...res.data);
                console.log(this.list)
                this.pageNum++;
                this.loading = false;
                if (this.list.length >= res.total) {
                    this.finished = true;
                }
            });
        }
    }
}
</script>
<style lang="less" scoped>
.zhzfzmain{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}
.item{
	width: 92%;
	margin-left: 4%;
	display: flex;
	flex-direction: column;
	line-height: 30px;
	border-bottom: 1px solid #ebedf0;
	.title{
		color: #333333;
		font-size: 18px;
		display: flex;
		align-items: center;
		margin-top: 10px;
		.bline{
			width: 4px;
			height: 20px;
			background-color: #28aff6;
		}
		span{
			margin-left: 10px;
		}
	}
	.xxj{
		margin-left: 20px;
        overflow:hidden; 
        text-overflow:ellipsis;
        display:-webkit-box; 
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2; 
		span{
			color: #999999;
		}
	}
}
</style>